import { useEffect } from "react";
import "./Maria.css";

import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Components/footer/Footer";

// Images
import MariaImg from "./images/Maria.png";

const Maria = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, []);

    return (<>

        <Navbar />

        <div className="maria-page-container">
            <h2 className="am-h2">The story of <span>Dr. Maria Montessori</span></h2>

            <div className="m-hero-section">
                <div className="m-quote-container">
                    <h1 className="m-quote-text">
                        "Education is a natural process carried out by the child and is not acquired by listening to words but by experiences in the environment."
                    </h1>
                    <p className="m-quote-author">- Dr. Maria Montessori</p>
                </div>

                <div className="m-image-container">
                    <img className="m-hero-img" src={MariaImg} alt="Dr. Maria Montessori with a child" />
                </div>
            </div>

            <div className="m-content-section">
                <p>
                    <span>Maria Montessori</span> was a true pioneer and innovator who developed what we now know as the <span>Montessori Method of education.</span> She was among the very first women in Italy to earn a medical degree in the late 19th century—a remarkable achievement at a time when higher education and professional fields were largely inaccessible to women. Her background in medicine and scientific research profoundly influenced the way she observed and understood children, not just as students but as individuals with unique needs, potential, and a natural rhythm of growth.
                </p>

                <p>
                    <span>Dr. Montessori believed that every child is born with an innate curiosity and an inner drive to learn.</span> She emphasized independence, freedom within carefully prepared limits, and active, hands-on learning with thoughtfully designed materials. For her, education was not about rote memorization or rigid instruction but about creating an environment where children could explore, discover, and grow at their own pace — <span>developing a lifelong love for learning.</span>
                </p>

                <p>
                    <span>In 1907, Montessori opened her first school, the Casa dei Bambini (“Children’s House”) in Rome.</span> This school became the living foundation of her philosophy, as she observed children flourish when given opportunities to learn independently. The remarkable success of her approach soon gained worldwide recognition, leading to the spread of Montessori schools across Europe, the United States, and eventually every continent. <span>Her method was embraced as a revolutionary alternative to traditional education,</span> placing the child at the center of the learning journey.
                </p>

                <p>
                    Today, Maria Montessori is remembered not only as an educator but as a visionary who transformed early childhood education forever. <span>Her philosophy continues to inspire schools and teachers </span>across the globe, helping children grow into confident, independent, responsible, and compassionate individuals. More than a century later, the Montessori Method remains a guiding light for <span>nurturing young minds — proving that her vision was not just ahead of its time, but timeless.</span>
                </p>
            </div>
        </div>

        <Footer />

    </>)
}

export default Maria;